// src/services/LabTestApi/Rating/ratingApi.js
import axios from 'axios';

// ✅ API Base URL
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://online-tech.in/api').replace(/\/+$/, '');

// ============================================================
// 1. FETCH RATING FOR SINGLE PRODUCT
// ============================================================
export const fetchRatingApi = async (productId, categoryId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/Rating/GetRatingDetail?CategoryId=${categoryId}&ProductId=${productId}`
    );
    
    let ratings = [];
    if (response.data && response.data.data && Array.isArray(response.data.data)) {
      ratings = response.data.data;
    } else if (Array.isArray(response.data)) {
      ratings = response.data;
    } else if (response.data && response.data.succeeded && response.data.data) {
      ratings = response.data.data;
    }
    
    const total = ratings.length;
    const sum = ratings.reduce((acc, r) => {
      const point = r.ratingpoint || r.RatingPoint || r.rating || 0;
      return acc + Number(point);
    }, 0);
    const average = total > 0 ? Math.round((sum / total) * 10) / 10 : 0;
    
    return {
      productId,
      categoryId,
      average,
      total,
      ratings
    };
  } catch (error) {
    console.error('❌ fetchRating error:', error);
    throw error;
  }
};

// ============================================================
// 2. FETCH RATINGS FOR MULTIPLE PRODUCTS (BULK)
// ============================================================
export const fetchAllRatingsApi = async (products) => {
  try {
    const ratingPromises = products.map(async (product) => {
      const { productId, categoryId } = product;
      
      try {
        const response = await axios.get(
          `${API_BASE_URL}/Rating/GetRatingDetail?CategoryId=${categoryId}&ProductId=${productId}`
        );
        
        let ratings = [];
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          ratings = response.data.data;
        } else if (Array.isArray(response.data)) {
          ratings = response.data;
        } else if (response.data && response.data.succeeded && response.data.data) {
          ratings = response.data.data;
        }
        
        const total = ratings.length;
        const sum = ratings.reduce((acc, r) => {
          const point = r.ratingpoint || r.RatingPoint || r.rating || 0;
          return acc + Number(point);
        }, 0);
        const average = total > 0 ? Math.round((sum / total) * 10) / 10 : 0;
        
        return {
          productId,
          categoryId,
          average,
          total,
          ratings
        };
      } catch (error) {
        console.error(`❌ Rating error for product ${productId}:`, error);
        return {
          productId,
          categoryId,
          average: 0,
          total: 0,
          ratings: [],
          error: true
        };
      }
    });
    
    const results = await Promise.all(ratingPromises);
    return results;
  } catch (error) {
    console.error('❌ fetchAllRatings error:', error);
    throw error;
  }
};

// ============================================================
// 3. INSERT RATING
// ============================================================
export const insertRatingApi = async (payload) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/Rating/InsertRating`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error('❌ insertRating error:', error);
    throw error;
  }
};

// ============================================================
// 4. UPDATE RATING
// ============================================================
export const updateRatingApi = async (payload) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/Rating/RatingUpdate`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error('❌ updateRating error:', error);
    throw error;
  }
};

// ============================================================
// 5. DELETE RATING
// ============================================================
export const deleteRatingApi = async (ratingId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/Rating/RatingDelete?Id=${ratingId}`
    );
    return response.data;
  } catch (error) {
    console.error('❌ deleteRating error:', error);
    throw error;
  }
};

// ============================================================
// 6. GET RATING DETAILS (For direct use)
// ============================================================
export const getRatingDetails = async (categoryId, productId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/Rating/GetRatingDetail?CategoryId=${categoryId}&ProductId=${productId}`
    );
    return response.data;
  } catch (error) {
    console.error('❌ getRatingDetails error:', error);
    throw error;
  }
};